@for (menuItem of sideMenuItems; track menuItem) {
  @if (deviceInfo.deviceTypeDetected === 'DESKTOP' || menuItem.showOnMobile) {
    <a
      class="menu-item {{ menuItem.class }}"
      #linkRef
      [routerLink]="
        menuItem.isDisabled(myProcess?.status) ? null : menuItem.getRouterLink(selectedWorkPermitId ?? myProcess?.id)
      "
      routerLinkActive="active"
      [attr.aria-current]="rla.isActive ? 'page' : null"
      [attr.aria-disabled]="menuItem.isDisabled(myProcess?.status) ? 'true' : null"
      [attr.tabindex]="menuItem.isDisabled(myProcess?.status) ? -1 : 0"
      [class.item-disabled]="menuItem.isDisabled(myProcess?.status)"
      #rla="routerLinkActive"
      nz-tooltip
      [nzTooltipTrigger]="
        isForeigner && menuItem.disabledItemTooltip && (!myProcess?.id || myProcess?.id === 'purchase') ? 'click' : null
      "
      nzTooltipTitle="{{
        menuItem.disabledItemTooltip && menuItem.isDisabled(myProcess?.status)
          ? (menuItem.disabledItemTooltip | translate)
          : ''
      }}"
      nzTooltipPlacement="right"
      nzTooltipOverlayClassName="disabled-menu-item-tooltip"
      [nzTooltipArrowPointAtCenter]="true"
      (keydown.space)="$event.preventDefault(); linkRef.click()">
      @if (menuItem.svgIcon) {
        <mat-icon class="menu-item-icon" [svgIcon]="menuItem.svgIcon" aria-hidden="true"> </mat-icon>
      }
      <span>{{ menuItem.mainLabelKey | translate }}</span>
    </a>
  }
}
